import { useBreakpoints } from "@vueuse/core";
import { Viewport } from "../constants/viewport";

export default () => {
  const breakpoints = useBreakpoints(Viewport);

  return {
    breakpoints,
  };
};
